<template>
  <InputComponent v-bind="$attrs">
    <RadioComponent v-model="comp" v-bind="$attrs" class="elder-input__element" />
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import RadioComponent from '@kvass/radio'

import { ValueComp } from '../utils'

export default {
  props: ['value', 'default'],
  computed: {
    comp: ValueComp(),
  },
  created() {
    if (this.default && this.value === undefined) this.comp = this.default
  },
  components: {
    InputComponent,
    RadioComponent,
  },
}
</script>
